import React from 'react';
import UiContent from '../../../../Components/Common/UiContent';
import BreadCrumb from '../../../../Components/Common/BreadCrumb';
import { Container } from 'reactstrap';
import WorkStatusList from './WorkStatusList';

const WorkStatus = () => {
	const breadcrumbLinks = [
		{ to: '#', label: 'Inicio', icon: 'icon-house' },
		{ to: '#', label: 'Derechos de Agua', icon: 'icon-droplets' },
		{ to: '#', label: 'Configuración', icon: 'icon-settings' },
	];

	return (
		<React.Fragment>
			<UiContent />
			<div className='page-content'>
				<Container fluid>
					<BreadCrumb title='Estados de Actividad' links={breadcrumbLinks} icon={'icon-toggle-right'} />
					<WorkStatusList/>
				</Container>
			</div>
		</React.Fragment>
	);
};

export default WorkStatus;
